<template>
  <b-field
    :label="$t('dateOfBirth')"
    label-position="on-border"
    custom-class="required"
  >
    <!--  Day  -->
    <b-select
      v-model="day"
      :placeholder="$t('day')"
      v-on:input="updateDateOfBirth()"
    >
      <option v-for="index in 31" :key="index" :value="index">
        {{ index < 10 ? `0${index}` : index }}
      </option>
    </b-select>

    <!--  Month  -->
    <b-select
      v-model="month"
      :placeholder="$t('month')"
      expanded
      v-on:input="updateDateOfBirth()"
    >
      <option v-for="index in 12" :key="index" :value="index">
        {{ index < 10 ? `0${index}` : index }} - {{ humanizeMonth(index) | capitalize }}
      </option>
    </b-select>

    <!--  Year  -->
    <b-select
      v-model="year"
      :placeholder="$t('year')"
      v-on:input="updateDateOfBirth()"
    >
      <option v-for="index in yearsRange()" :key="index" :value="index">
        {{ index }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { HelpersMixin } from "@/mixins/HelpersMixin";
import VueI18n from "vue-i18n";
import moment from "@/services/momentjs";

export default {
  name: "DateOfBirth",
  mixins: [LocaleMixin, HelpersMixin],
  props: ["value"],

  data() {
    return {
      year: null,
      month: null,
      day: null
    };
  },

  beforeMount() {
    if (this.value !== null) {
      let date = moment(this.value);
      this.day = date.date();
      this.month = date.month() + 1;
      this.year = date.year();
    }
  },

  methods: {
    humanizeMonth: function(index) {
      return moment(`2000-${('0' + index).slice(-2)}-01`).format("MMMM");
    },

    yearsRange: function() {
      let years = [];
      let currentYear = moment().year();
      for (let year = currentYear - 100; year <= currentYear; year++) {
        years.push(year);
      }
      return years.reverse();
    },

    updateDateOfBirth: function() {
      if (this.day !== null && this.month !== null && this.year !== null) {
        const month = ('0' + this.month).slice(-2)
        const day = ('0' + this.day).slice(-2)
        let date = moment(`${this.year}-${month}-${day}`).format(
          "YYYY-MM-DD"
        );
        this.$emit("input", date);
      }
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        dateOfBirth: "Date of birth",
        year: "Year",
        month: "Month",
        day: "Day"
      },
      fr: {
        dateOfBirth: "Date de naissance",
        year: "Année",
        month: "Mois",
        day: "Jour"
      }
    }
  })
};
</script>

<style lang="scss" src="../../assets/styles/buefy/base.scss" />
